import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Learn about staking and risks',
});
